import { Injectable } from '@angular/core';
import { HERE_API_KEY } from '@curbnturf/entities';
import '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp';
import Platform = H.service.Platform;

@Injectable({
  providedIn: 'root',
})
export class HereMapService {
  platform: Platform;

  constructor() {
    this.platform = new H.service.Platform({
      apikey: HERE_API_KEY,
    });
  }
}
